import { ReactLenis } from 'lenis/react';
import '@/App.css';
import Navbar from '@/components/Navbar';
import Hero from '@/components/Hero';
import Marquee from '@/components/Marquee';
import PhotoDivider from '@/components/PhotoDivider';
import About from '@/components/About';
import BestSellers from '@/components/BestSellers';
import MenuSection from '@/components/MenuSection';
import Location from '@/components/Location';
import Reviews from '@/components/Reviews';
import Social from '@/components/Social';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';

export default function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="grain min-h-screen bg-[#0D0D0F] text-zinc-100">
        <Navbar />
        <main>
          <Hero />
          <Marquee />
          <BestSellers />
          <PhotoDivider image="03" text="Feito com amor" testid="divisor-1" />
          <MenuSection />
          <PhotoDivider image="04" text="Só amor e obsessão" testid="divisor-2" />
          <Location />
          <PhotoDivider image="07" text="Siga o Riths" testid="divisor-3" />
          <Social />
          <PhotoDivider image="05" text="Desde o primeiro burger" testid="divisor-4" />
          <About />
          <PhotoDivider image="09" text="Quem prova, volta" testid="divisor-5" />
          <Reviews />
          <PhotoDivider image="06" text="Fale com a gente" testid="divisor-6" />
          <Contact />
          <PhotoDivider image="10" text="Sex & Sáb até às 2h" testid="divisor-7" />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
}
